// App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';

// Page Components
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Projects from './pages/Projects';
import Gallery from './pages/Gallery';
import Login from './pages/Login';
import EscapeTheMaze from './pages/projects/EscapeTheMaze';
import PainfulPaint from './pages/projects/PainfulPaint';
import PyrrhicWar from './pages/projects/PyrrhicWar';
import PyrrhicWarCompendium from './pages/projects/PyrrhicWarCompendium';
import PredictivePolicing from './pages/projects/PredictivePolicing';
import PyrrhicWarMap from './pages/projects/PyrrhicWarMap';
import KillTeamCampaign from './pages/projects/KillTeamCampaign';
import Expedition from './pages/projects/Expedition';
import ExpeditionMap from './pages/projects/ExpeditionMap';
import Pirate from './pages/projects/Pirate';
import PirateCompendium from './pages/projects/PirateCompendium';
import PirateCharacterSheet from './pages/projects/PirateCharacterSheet';
import PirateNpcBuilder from './pages/projects/PirateNpcBuilder';
import PirateCustom from './pages/projects/PirateCustom';
import DeploymentZoneCreator from './pages/projects/DeploymentZoneCreator';
import SixShotShowdown from './pages/projects/SixShotShowdown';

export default function App() {
  const mobile = window.innerWidth <= 768;
  console.log("Is mobile:", mobile);
              
  return (
    <Router>
      <Routes>
        {/* Fullscreen, no layout */}
        <Route path="/projects/PredictivePolicing" element={<PredictivePolicing />} />
        <Route path="/projects/KillTeamCampaign" element={<KillTeamCampaign />} />
        <Route path="/projects/PyrrhicWar" element={<PyrrhicWar />} />
        <Route path="/projects/PyrrhicWarCompendium" element={<PyrrhicWarCompendium />} />
        <Route path="/projects/PyrrhicWarMap" element={<PyrrhicWarMap />} />
        <Route path="/projects/Pirate" element={<Pirate />} />
        <Route path="/projects/PirateCompendium" element={<PirateCompendium />} />
        <Route path="/projects/PirateCharacterSheet" element={<PirateCharacterSheet />} />
        <Route path="/projects/PirateNpcBuilder" element={<PirateNpcBuilder />} />
        <Route path="/projects/PirateCustom" element={<PirateCustom />} />
        <Route path="/projects/PirateCustomItem" element={<PirateCustom />} />
        <Route path="/projects/Expedition" element={<Expedition />} />
        <Route path="/projects/ExpeditionMap" element={<ExpeditionMap />} />
        <Route path="/projects/DeploymentZoneCreator" element={<DeploymentZoneCreator />} />

        {/* Other pages — With layout */}
        <Route
          path="*"
          element={
            <div
              style={{
                minHeight: '100vh',
                backgroundImage: `url('/images/Body.png')`,
                backgroundBlendMode: 'multiply',
                backgroundSize: 'cover',
                backgroundRepeat: 'repeat',
                backgroundPosition: 'center',
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                overflow: 'hidden',
                zIndex: 0,
              }}


            >
              {/* Sidebars */}
              {!mobile && (
                <>
                  {/* Left Sidebar */}
                  <div
                    style={{
                      position: 'fixed',
                      top: 0,
                      left: -4,
                      width: '54px',
                      height: '100vh',
                      backgroundImage: "url('/images/SideNavigationBar2.png')",
                      backgroundSize: '100% 100%',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'left top',
                      boxShadow: '4px 0px 12px rgba(0, 0, 0, 0.5)',
                      zIndex: 3,
                    }}
                  />
                  {/* Right Sidebar */}
                  <div
                    style={{
                      position: 'fixed',
                      top: 0,
                      right: -4,
                      width: '54px',
                      height: '100vh',
                      backgroundImage: "url('/images/SideNavigationBar.png')",
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      boxShadow: '-4px 0px 12px rgba(0, 0, 0, 0.5)',
                      zIndex: 3,
                    }}
                  />
                </>
              )}
              <Header />

              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/login" element={<Login />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/projects/EscapeTheMaze" element={<EscapeTheMaze />} />
                <Route path="/projects/PainfulPaint" element={<PainfulPaint />} />
                <Route path="/projects/SixShotShowdown" element={<SixShotShowdown />} />
              </Routes>
            </div>
          }
        />
      </Routes>
    </Router>
  );
}
